<script>
  import { ChevronLeft, ChevronRight } from 'lucide-svelte';
  import { onMount } from "svelte";
  import * as pdfjs from "pdfjs-dist";
  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

  export let pageCount;
  export let path = "";

  /**
   * Are we currently rendering or not
   */
  let pageRendering = false;

  /**
   * What page are we on
   */
  let page = 1;
  let maxPage = 1;

  // Canvas for PDFs
  let pdfCanvas;
  let pdfDoc;
  let canvasContext;

  /**
   * Send an analytics event
   *
   * @param direction - next or previous
   */
  function triggerAnalytics(direction) {
    try {
      window.posthog.capture("PDF Page Click", {
        direction: direction
      });
    } catch (err) {
      console.log(err);
    }
  }

  /**
   * Trigger the previous page
   */
  function previousPage() {
    page--;
    renderPage(page);
    triggerAnalytics("previous");
  }

  /**
   * Trigger the next page
   */
  function nextPage() {
    page++;
    renderPage(page);
    triggerAnalytics("next");
  }

  /**
   *
   * @param pg - page
   */
  async function renderPage(pg) {
    pageRendering = true;

    const p = await pdfDoc.getPage(pg);
    const viewport = p.getViewport({ scale: 1 });
    pdfCanvas.width = viewport.width;
    pdfCanvas.height = viewport.height;

    const renderCtx = {
      canvasContext,
      viewport
    };

    p.render(renderCtx);

    pageRendering = false;
  }

  onMount(async () => {
    canvasContext = pdfCanvas.getContext("2d");
    console.log("got path: ", path);

    const pdfData = await fetch(path, {
      redirect: "follow"
    });

    try {
      pdfDoc = await pdfjs.getDocument({ data: await pdfData.arrayBuffer() })
        .promise;
      maxPage = pdfDoc.numPages;
      // Set the number of max pages
      renderPage(1);
    } catch {
      maxPage = 0;
    }
  });
</script>

<div class="w-full flex flex-col gap-8 bg-neutral-50">
  <div class="mx-auto bg-neutral-50 px-12 h-[400px] sm:h-[800px]">
    <canvas
      bind:this={pdfCanvas}
      class="rounded-sm mx-auto my-6 shadow max-h-full"
      style="width:100%"
    />
  </div>

  <div class="flex gap-4 mx-auto mb-4 text-neutral-700">
    <div class="w-10 h-10 px-8 py-3  {page - 1 < 1 ? "bg-orange-50" : "bg-orange-500"} rounded-md flex justify-center items-center gap-2.5">
      <div class="w-6 h-6 relative">
        <button
          on:click={previousPage}
          disabled={page - 1 < 1}
        >
          <ChevronLeft color={page - 1 < 1 ? "orange" : "white"} />
        </button>
      </div>
    </div>
    <div class="h-10 p-3 rounded-md backdrop-blur-lg flex justify-center items-center gap-2.5">
      <div class="text-blue-900 text-base font-medium leading-6 break-words">
	      {page}/{maxPage}{pageCount ? " of " + pageCount : ""}
      </div>
    </div>
    <div class="w-10 h-10 px-8 py-3 {page + 1 > maxPage ? "bg-orange-50" : "bg-orange-500"} rounded-md flex justify-center items-center gap-2.5">
      <div class="w-6 h-6 relative">
        <button
          on:click={nextPage}
          disabled={page + 1 > maxPage}
        >
	  <ChevronRight color={page + 1 > maxPage ? "orange" : "white"} />
        </button>
      </div>
    </div>
  </div>
</div>
